import { useState } from 'react';
import { PROLONGATION_MOIS, type ConservationFiche } from '@rh/shared';
import { appel } from '../api';
import { Erreur } from './Etat';

interface Props {
  personneId: string;
  onProlongee: (fiche: ConservationFiche) => void;
}

/** Repousse de deux ans l'anonymisation annoncée d'une personne (rôle rh). */
export function Prolonger({ personneId, onProlongee }: Props) {
  const [envoi, setEnvoi] = useState(false);
  const [erreur, setErreur] = useState<string | null>(null);

  async function prolonger(): Promise<void> {
    setEnvoi(true);
    setErreur(null);
    try {
      onProlongee(await appel<ConservationFiche>(`/personnes/${personneId}/prolonger`, { method: 'POST' }));
    } catch (e) {
      setErreur(e instanceof Error ? e.message : 'Prolongation impossible');
    } finally {
      setEnvoi(false);
    }
  }

  return (
    <>
      <button type="button" className="bouton-second" disabled={envoi} onClick={() => void prolonger()}>
        Garder {PROLONGATION_MOIS / 12} ans de plus
      </button>
      {erreur && <Erreur message={erreur} />}
    </>
  );
}
